import React, { Component } from "react";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import axios from "axios";
import Cookies from "universal-cookie";
import { API as url1 } from "../../config";
import { FiMessageCircle, FiCheckCircle, FiEye } from "react-icons/fi";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import {
  APPROVE,
  FEED,
  SELL_PRODUCT,
  VIEW_DET,
  VIEW_IMG,
} from "../../constants/url";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  DialogTitle,
  Typography,
  Dialog,
  DialogActions,
  TextField,
  Paper,
} from "@mui/material";
import { FaImage } from "react-icons/fa";
import ImageModal from "../../images/imageModal";
import { ERR_ALERT_TITLE, ERR_GETTING, ERR_POSTING, SUCC_ALERT_TITLE, SUCC_APPROVE_TEXT, SUCC_APPROVE_TITLE, SUCC_FEEDBACK } from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";
const cookies = new Cookies();

class rejectedList extends Component {
  constructor() {
    const localRole = JSON.parse(localStorage.getItem("role"))
    super();
    this.state = {
      data: "",
      replay: "",
      images: [],
      open: false,
      open1: false,
      open2: false,
      feedId: "",
      name: "",
      customer: "",
      mobile_no: "",
      title: "",
      description: "",
      qty: "",
      unit: "",
      expDate: "",
      transpot_status: "",
      organic_status: "",
      safe_status: "",
      permissions: localRole && localRole.permissions ? localRole.permissions : "All",
      isSendingFeedback: false 
    };
    this.edit = this.edit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }
  componentDidMount() {

    const requestUrl = `${SELL_PRODUCT}/rejectedlist/`;
    privateApiCall(requestUrl, "GET")
      .then(
        (res) => {
          const k = 1;

          for (let i = 0; i < res.data.data.length; i++) {
            res.data.data[i].sno = k + i;
          }

          this.setState({ data: res.data.data });
        },
        (err) => {
          Swal.fire({
            title: `${ERR_ALERT_TITLE}`,
            text: `${err}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      )
      .catch((err) => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });

  }

  addSerialNumbers(data) {
    return data.map((item, index) => ({
      ...item,
      sno: index + 1
    }));
  }

  handleSearch(e) {
    const searchValue = e.target.value;
    const requestUrl = `${SELL_PRODUCT}/search_sell_rejectedlist?query=${searchValue}&`;

    privateApiCall(requestUrl, "GET")
      .then((response) => {
        if (response.data && response.data.data) {
          const dataWithSerialNumbers = this.addSerialNumbers(response.data.data);
          this.setState({ data: dataWithSerialNumbers });
        } else {
          this.setState({ data: [] });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });
  }


  handleClose = () => {
    this.setState({ open: false });
  };

  handleClose1 = () => {
    this.setState({ open1: false });
  };
  handleClose2 = () => {
    this.setState({ open2: false });
  };
  handleChange(event) {
    this.setState({
      replay: event.target.value,
    }); // setValues({ ...values, error: false, [name]: e.target.value });
  }
  handleReplay = (event) => {
    event.preventDefault();
    this.setState({ isSendingFeedback: true });
    const requestUrl = `${SELL_PRODUCT}/replayToSProduct/?_id=${this.state.feedId}&replay=${this.state.replay}`
    privateApiCall(requestUrl, "GET")
      .then((res) => {
        if (res.data.status) {
          const requestUrl = `${SELL_PRODUCT}/rejectedlist/`
          privateApiCall(requestUrl, "GET")
            .then((res) => {
              const k = 1;
              for (let i = 0; i < res.data.data.length; i++) {
                res.data.data[i].sno = k + i;
              }
              this.setState({
                open2: false,
                replay: "",
                data: res.data.data,
                isSendingFeedback: false
              });

              // Show success message
              Swal.fire({
                title: `${SUCC_ALERT_TITLE}`,
                text: `${SUCC_FEEDBACK}`,
                icon: "success",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            })
            .catch((err) => {
              this.setState({ isSendingFeedback: false });
              Swal.fire({
                title: `${ERR_ALERT_TITLE}`,
                text: `${ERR_POSTING}`,
                icon: "error",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            });


        }
      })
      .catch((err) => {
        this.setState({ isSendingFeedback: false });
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_POSTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });



  };

  edit(cell, row, extraData, index) {
    const handleImageClick = () => {
      const imagesData = [row.image1, row.image2, row.image3, row.image4];

      const filteredImagesData = imagesData.filter(
        (image) => image !== undefined && image !== null && image !== ""
      );

      this.setState({ images: filteredImagesData });
      this.setState({ open: true });
    };
    const hasImageData = [row.image1, row.image2, row.image3, row.image4].some(
      (image) => image !== undefined && image !== null && image !== ""
    );
    const handleS = (e) => {

      this.setState({ feedId: row.id });
      this.setState({ open2: true });

    };
    const handlePOP = (e) => {
      const {
        customer,
        mobile_no,
        name,
        availableDate,
        expDate,
        description,
        freeDelivery,
        chargesAfter,
        title,
        qty,
        price,
        location,
        unit,
        auction_status,
        safe_status,
        organic_status,
        transpot_status,
      } = row;
      this.setState({
        customer: customer,
        mobile_no: mobile_no,
        name: name,
        availableDate: availableDate,
        expDate: expDate,
        description: description,
        freeDelivery: freeDelivery,
        chargesAfter: chargesAfter,
        title: title,
        qty: qty,
        price: price,
        location: location,
        unit: unit,
        auction_status,
        safe_status,
        organic_status,
        transpot_status,
      });
      this.setState({ open1: true });
    };

    const handleOnChange = (event) => {
      event.preventDefault();



      Swal.fire({
        title: `Approve ${row.title}`,
        text: "",
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          const requestUrl = `${SELL_PRODUCT}/approveProduct/${row.id}/`
          privateApiCall(requestUrl, "POST", null)
            .then((res) => {
              if (res.status === 200) {
                var selections = this.state.data;
                selections.splice(index, 1);

                this.setState({
                  data: selections,
                });

                // Show success message
                Swal.fire({
                  title: `${SUCC_APPROVE_TITLE}`,
                  text: `${SUCC_APPROVE_TEXT} `,
                  icon: "success",
                  confirmButtonText: "OK"
                });
              }
            })
            .catch((error) => {
              // Show error message
              Swal.fire({
                title: `${ERR_ALERT_TITLE}`,
                text: `${ERR_POSTING}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            });

        }
      });
    };

    return (
      <span>
        {this.state.permissions.some(item => item.keyword === "sellProductRejectedList" && item.isApprove == true) &&
          <>
            <i className="" data-tooltip-id="1" data-tooltip-content={`${APPROVE}`}>
              {" "}
              <FiCheckCircle onClick={handleOnChange} color="#4fbde9" size="20" />
            </i>
            <Tooltip id="1" />
          </>}
        {this.state.permissions.some(item => item.keyword === "sellProductRejectedList" && item.isFeedback == true) &&
          <>
            {row.replay !== "" ? (
              <i
                className="ml-1"
                data-tooltip-id="2"
                data-tooltip-content={`${FEED}`}
              >
                {" "}
                <FiMessageCircle onClick={handleS} color="#769A0F" size="20" />
              </i>
            ) : (
              <i
                className="ml-1"
                data-tooltip-id="2"
                data-tooltip-content={`${FEED}`}
              >
                {" "}
                <FiMessageCircle onClick={handleS} color="#f9bc0b" size="20" />
              </i>
            )}
            <Tooltip id="2" />
          </>}
        <i
          className="ml-1"
          data-tooltip-id="3"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handlePOP} color="#9368f3" size="20" />
        </i>
        <Tooltip id="3" />

        {hasImageData && (
          <i
            className="ml-1"
            data-tooltip-id="4"
            data-tooltip-content={`${VIEW_IMG}`}
          >
            {" "}
            <FaImage onClick={handleImageClick} color="green" size="17" />
          </i>
        )}
        <Tooltip id="4" />
      </span>
    );
  }



  render() {
    return (
      <div id="wrapper">
        <Topbar backgroundColor="#769A0F" ar />
        <Sidebar type="sellProducts" />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title float-left">List Products - Rejected List</h4>

                    <ol className="breadcrumb float-right">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">List Products</li>
                      <li className="breadcrumb-item active">Rejected List</li>
                    </ol>

                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card-box">
                    <div
                      style={{
                        width: "98%",
                      }}
                    >
                      <div style={{ marginLeft: 'auto', width: '200px', marginBottom: "20px", position: 'relative' }}>
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{ width: '100%', paddingLeft: '30px', boxSizing: 'border-box' }}
                          onChange={(e) => {
                            this.handleSearch(e);
                            if (e.target.value) {
                              e.target.nextSibling.style.display = 'none';
                            } else {
                              e.target.nextSibling.style.display = 'block';
                            }
                          }}
                        />
                        <i
                          className="fas fa-search"
                          style={{
                            position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#aaa', pointerEvents: 'none'
                          }}
                        ></i>
                      </div>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">S.No</TableCell>
                              <TableCell align="left">Customer</TableCell>
                              <TableCell align="left">Mobile</TableCell>
                              <TableCell align="left">Title</TableCell>
                              <TableCell align="left">Price</TableCell>
                              <TableCell align="left">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.isArray(this.state.data) &&
                              this.state.data.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell align="left">{row.sno}</TableCell>
                                  <TableCell align="left">
                                    {row.customer}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.mobile_no}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.title}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.price}
                                  </TableCell>

                                  <TableCell align="left">
                                    {this.edit(null, row, null, index)}
                                  </TableCell>
                                </TableRow>
                              ))}
                            <ImageModal
                              open={this.state.open}
                              handleClose={this.handleClose}


                              imageSrc={this.state.images}
                            />
                            <Dialog
                              open={this.state.open1}
                              onClose={this.handleClose1}
                              aria-labelledby="details-modal-title"
                              aria-describedby="details-modal-description"
                              style={{
                                maxHeight: "80vh",
                                overflowY: "auto",
                                marginTop: "100px",
                              }}
                              fullWidth
                              disableEnforceFocus
                              maxWidth="lg"
                            >
                              <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                className="modal-content"
                              >
                                <Grid item xs={12} className="modal-header">
                                  <h5 id="details-modal-title">
                                    {" "}
                                    Product Details
                                  </h5>
                                  <Button
                                    onClick={this.handleClose1}
                                    color="inherit"
                                  >
                                    {" "}
                                    <span
                                      style={{ fontSize: "20px" }}
                                      aria-hidden="true"
                                    >
                                      &#128473;
                                    </span>
                                  </Button>
                                </Grid>
                                <Grid item xs={12} className="modal-body">
                                  <Table className="col-12">
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Customer Name
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.customer}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Customer Mobile
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.mobile_no}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Product Title
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.title}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Description
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.description}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Unit
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.unit}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Quantity
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.qty}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Price
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.price}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Location
                                      </TableCell>
                                      <TableCell className="text-dark text-right font-weight-normal">
                                        {this.state.location}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Available Date
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        {this.state.availableDate}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Expiry Date
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        {this.state.expDate}
                                      </TableCell>
                                    </TableRow>
                                    {/* <TableRow>
                                      <TableCell className="text-left">
                                        Free Delivery
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        {this.state.freeDelivery}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Charges After
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        {this.state.chargesAfter}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className="text-left">
                                        Features
                                      </TableCell>
                                      <TableCell
                                        className="text-dark text-right font-weight-normal"
                                      >
                                        <div className="row justify-content-end">
                                          {this.state.auction_status ===
                                            "1" && (
                                              <img
                                                className="img-responsive "
                                                src={"/assets/icons/bid_icon.png"}
                                                alt="user"
                                                style={{
                                                  width: "40px",
                                                  height: "40px",
                                                }}
                                              />
                                            )}
                                          {this.state.safe_status === "1" &&
                                            this.state.organic_status ===
                                            "1" && (
                                              <img
                                                className="img-responsive ml-1"
                                                src={
                                                  "/assets/icons/organi_1.jpg"
                                                }
                                                alt="user"
                                                style={{
                                                  width: "40px",
                                                  height: "40px",
                                                }}
                                              />
                                            )}

                                          {this.state.safe_status === "1" &&
                                            this.state.organic_status ===
                                            "0" && (
                                              <img
                                                className="img-responsive ml-1"
                                                src={
                                                  "/assets/icons/safe_icon.jpg"
                                                }
                                                alt="user"
                                                style={{
                                                  width: "40px",
                                                  height: "40px",
                                                }}
                                              />
                                            )}

                                          {this.state.transpot_status ===
                                            "1" && (
                                              <img
                                                className="img-responsive ml-1"
                                                src={"/assets/icons/trucks.png"}
                                                alt="user"
                                                style={{
                                                  width: "40px",
                                                  height: "40px",
                                                }}
                                              />
                                            )}
                                        </div>
                                      </TableCell>
                                    </TableRow> */}
                                  </Table>
                                </Grid>
                                <Grid item xs={12} className="modal-footer">
                                  <Button
                                    onClick={this.handleClose1}
                                    variant="outlined"
                                    color="error"
                                  >
                                    Close
                                  </Button>
                                </Grid>
                              </Grid>
                            </Dialog>
                            <Dialog
                              open={this.state.open2}
                              onClose={this.handleClose2}
                              maxWidth="lg"
                              fullWidth
                              centered
                              disableEnforceFocus
                            >
                              <div
                                style={{
                                  backgroundColor: "#fff",
                                  padding: "20px",
                                  // minWidth: '500px',
                                  borderRadius: "8px",
                                }}
                              >
                                <h3>Feedback</h3>
                                <form onSubmit={this.handleReplay}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <div className="text-left text-dark mb-1">
                                        Message
                                      </div>
                                      <TextField
                                        type="text"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        value={this.state.replay}
                                        placeholder="Message"
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    justifyContent="flex-end"
                                    style={{ marginTop: "20px" }}
                                  >
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      onClick={this.handleClose2}
                                      style={{ marginRight: "8px" }}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      disabled={this.state.isSendingFeedback}
                                      style={{
                                        backgroundColor: "#769A0F",
                                        color: "#fff",
                                      }}                                     >
                                    {this.state.isSendingFeedback ? "Sending..." : "Send"}
                                    </Button>
                                  </Grid>
                                </form>
                              </div>
                            </Dialog>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default rejectedList;
